module.exports = __webpack_public_path__ + "icon-documentation.c6260f5f8c80bd50b84a694d20a9b92c.png";